// extracted by mini-css-extract-plugin
export default {"container":"container__tGEu8","wrapper":"wrapper__bc3lt","input":"input__hior_","numberInput":"numberInput__piNUl"};